import { useEffect, useMemo, useState } from "react";
import { I_GENERIC_ITEMS } from "@/src-refactor/modules/shared/model/interface/items.interface";
import { Grid } from "@mui/material";
import MxTypography from "../../MxTypography";
import { useLazyGetAgenciesQuery } from "@/src-refactor/modules/store/qrtk/services/agency/agency.qrtk";
import MxImageBlur from "@rf-l1/images/MxImageBlur";
import { MxAutoCompleteFieldProps } from "./MxAutoCompleteField/model/MxAutoCompleteField";
import MxAutoCompleteField from "./MxAutoCompleteField/MxAutoCompleteField";
import { MxItemAgencies } from "@rf-l1/items-autocomplete/MxItemAgencies";
import HCheckArray from "@rf-helper/check-have-value";

type omit = "items";

export type MxSelectAgenciesFieldProp = Omit<MxAutoCompleteFieldProps, omit>;
const MxSelectAgenciesField = (props: MxSelectAgenciesFieldProp) => {
  const [getAgencies, { data, isLoading, status }] = useLazyGetAgenciesQuery();

  const Items: I_GENERIC_ITEMS[] = useMemo(() => {
    if (HCheckArray(data?.data)) {
      return data?.data.map((agency, i) => ({
        label: agency.name,
        value: agency.id,
        id: agency.id,
        name: agency.name,
        extraData: {
          agencyData: agency
        }
      })) as I_GENERIC_ITEMS[];
    }

    return [];
  }, [data?.data, status]);

  const onSearch = (v: string) => {
    getAgencies({
      query: {
        search: v
      }
    });
  };

  useEffect(() => {
    getAgencies({
      query: {
        search: ""
      }
    });
  }, []);

  return (
    <MxAutoCompleteField
      {...props}
      onSearch={onSearch}
      items={Items}
      loading={isLoading}
      componentItem={MxItemAgencies}
    />
  );
};

export default MxSelectAgenciesField;
